import axios from 'axios'
import qs from 'qs'
import dayjs from 'dayjs'

const _isDevEnv = process.env.NODE_ENV === 'development'

const commonH = {}

if (!_isDevEnv) {
  try {
    const host = location.host
    const isPreRelease = /^bgpumpreport-porland-beta.pancares.com$/i.test(host)
    const isPord = /^bgpumpreport.pancares.com$/i.test(host)
    if (isPreRelease) {
      commonH['version'] = 'pre'
    }
    if (isPord) {
      commonH['version'] = 'eu'
    }
  } catch (error) {
    console.error('被捕获:' + error)
  }
}

export const cgmApi = {
  fetchCgmRecord: function (data) {
    if (!Number.isNaN(+window?._startOfWeek)) {
      data['startOfWeek'] = window?._startOfWeek
    }
    data = qs.stringify(data)
    return axios.post(`/user/query_agp`, data, {
      headers: { ...commonH, 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  },
  fetchAidexRecord: function (data) {
    if (!Number.isNaN(+window?._startOfWeek)) {
      data['startOfWeek'] = window?._startOfWeek
    }
    data = qs.stringify(data)
    return axios.post(`/user/query_aidex_agp`, data, {
      headers: { ...commonH, 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  }
}

export const bgApi = {
  getBgReport: function (data) {
    // data = qs.stringify(data)
    if (data.lang === 'polish') {
      data.lang = 'pl'
    }
    if (window && window._query && window._query.rrpId) {
      data.rrpId = window._query.rrpId
    }
    if (!Number.isNaN(+window?._startOfWeek)) {
      data['startOfWeek'] = window?._startOfWeek
    }
    // return axios.post(`/web/patient-data/getBgAndPumpReport`, data, {
    return axios.post(`/api/v2/monitor/pumpApp/getReportData`, data, {
      headers: {
        ...commonH,
        [data.lang ? 'Accept-Language' : '']: data.lang
      }
    }).then(res => { // 注意，在响应拦截器中你可能直接返回了data，所以这里接收到的是处理后的数据
      try {
        _russianAjaxResponseNeedConvertWillModifyResObject(res)
      } catch (error) {
        // eslint-disable-next-line
      }
      return res
    })

    // get 请求
    // data = qs.stringify(data)
    // return axios.get(`/web/patient-data/getBgAndPumpReport?${data}`, {
    //   headers: {
    //     ...commonH,
    //     'Content-Type': 'application/x-www-form-urlencoded'
    //   }
    // })
  }
}

export const pumpApi = {
  getPumpReport: bgApi.getBgReport
}

function _russianAjaxResponseNeedConvertWillModifyResObject(res = {}) {
  // 特殊化处理1： 基础率。目前服务端会返回很多基础率>8套，我做一个排序筛选取最新
  _basalSettingSpecialTreatWillModifyRes(res)

  // 特殊化处理2: dataUploadHis。因为当天，然后通过俄罗斯定制的pump app上传的泵数据，没有usb的那种上传记录，导致一直画到的今天的24:00了。所以通过插入一个假的uploadHis来保证基础率画到此时此刻
  _fakeUploadForDrawingPurposeWillModifyRes(res)

  // 从otherData2里头分析出otherData这种数据。下面这些业务需要: 临时基础率
  _analyseToGetOtherDataForTempBasal(res)

  // basalRateInfoMsg俄罗斯版从库里头取出来，时间字段叫做recordTime。而老的报告是需要dateTimeStr，所以将如果没有设置dateTimeStr的话，将recordTime的值存一份到dateTimeStr
  _basalRateInfoMsgSpecialTreatWillModifyRes(res)
  
  return res
}

function _basalSettingSpecialTreatWillModifyRes(res = {}) {
  // 特殊化处理1： 基础率。目前服务端会返回很多基础率>8套，我做一个排序筛选取最新
  const oldBasalsSettings = res.data.data.basalRateBaseSetting
  const tmp = {}
  oldBasalsSettings.forEach(setting => {
    const { settingIndex } = setting
    if (!tmp[settingIndex]) {
      tmp[settingIndex] = []
    }
    const arr = tmp[settingIndex]

    arr.push(setting)
    arr.sort((first, second) => {
      // 倒序
      return dayjs(second.createTime) - dayjs(first.createTime)
    }) // 需要影响arr数组本身
  })

  const narr = []

  const keys = Object.keys(tmp)

  keys.forEach(k => {
    const arr = tmp[k]
    const t = arr[0]
    narr.push(t)          
  })

  // 赋值回去
  res.data.data.basalRateBaseSetting = narr
  console.error(`最后处理过的基础率设置信息数组如下：`, narr)
  // End 特殊化处理1： 基础率。目前服务端会返回很多基础率>8套，我做一个排序筛选取最新

  return res
}

function _fakeUploadForDrawingPurposeWillModifyRes(res = {}) {
  // 特殊化处理2: dataUploadHis。因为当天，然后通过俄罗斯定制的pump app上传的泵数据，没有usb的那种上传记录，导致一直画到的今天的24:00了。所以通过插入一个假的uploadHis来保证基础率画到此时此刻
  const oldUploads = (res.data.data.dataUploadHis || []).slice()
  const $now = dayjs()
  oldUploads.push({
    uploadTimeStr: $now + '',
    fake: true,
    fakeNow: true,
    fakeNowStr: $now.format('YYYY-MM-DD hh:mm:ss'),
    fakeNowStr2: $now.format('YYYY-MM-DD hh:mm:ss Z'),
    sourceType: 2 // wifi
  })
  res.data.data.dataUploadHis = oldUploads // 填充回去
  console.error(`时区:${dayjs.tz()} 最后处理过上传记录：`, oldUploads)
  // End 特殊化处理2: dataUploadHis。因为当天，然后通过俄罗斯定制的pump app上传的泵数据，没有usb的那种上传记录，导致一直画到的今天的24:00了。所以通过插入一个假的uploadHis来保证基础率画到此时此刻
  return res
}

function _analyseToGetOtherDataForTempBasal(res = {}) {
  // http://yapi.microtechmd.com:3000/project/4034/interface/api/31599
  const $data = res.data.data
  const { otherData2 = [] } = $data

  otherData2.forEach((r, i) => {
    r._resIndex = i
    const { event } = r

    if (+event === 112) {
      // 基础率运行事件
      Object.assign(r, {
        eventPort: 0,
        eventType: 8
      })
      r.dateTimeStr = r.appTime
      r.eventValue = r.durationOrTotalExtends / 3600 * 10 // 持续时间;equil pda(胡路生)那边eventValue单位是0.1小时；而durationOrTotalExtends是秒。最后报告需要的是以小时为单位

      r.statusByte0 = r.unitOrExtendsTime // 单位或延长量时间s 大剂量输注记录: 延长量时间(单位:秒) 临时基础率记录: 临时基础率单位(1:单位U/hr, 2:单位%)
      r.statusByte1 = r.totalBolusOrBasalId // 当前基础率序号

      const isPercent = +r.statusByte0 === 2

      r.statusShort1 = r.bolusRateOrRawValue // 单位为U的时候 rate * 160 ,单位为 %为百分比；
      if (!isPercent) {
        // 值模式，具体的值是存在r.statusShort0
        r.statusShort0 = r.bolusRateOrRawValue // 单位为U的时候 rate * 160 ,单位为 %为百分比；
      }
    } else if (+event === 111) {
      // 基础率停止事件
      Object.assign(r, {
        eventPort: 0,
        eventType: 10
      })
      r.dateTimeStr = r.appTime      
    }
  })

  // 数据回填
  if (Array.isArray($data.otherData)) {
    $data.otherData.push(...otherData2)
  } else {
    $data.otherData = otherData2
  }
  // 数据回填2,每一天(dailyList)里头的otherData也要回填
  if (Array.isArray($data.dailyList)) {
    $data.dailyList.forEach(day => {
      if (Array.isArray(day.otherData)) {
        day.otherData.push(...otherData2)
      } else {
        day.otherData = otherData2
      }
    })
  }

  return res
}

function _basalRateInfoMsgSpecialTreatWillModifyRes(res = {}) {
  // http://yapi.microtechmd.com:3000/project/4034/interface/api/31599
  // 老报告需要dateTimeStr
  const basalRateInfoMsg = res.data.data.basalRateInfoMsg

  if (Array.isArray(basalRateInfoMsg)) {
    basalRateInfoMsg.forEach(v => {
      if (['undefined', 'null', ''].includes(`${v.dateTimeStr}`.trim().toLowerCase())) {
        v.dateTimeStr = v.recordTime        
      }
    })
  }
}
